import { format } from 'date-fns'

import React from 'react'
import { Flex } from 'components/Layout'
import { Text } from 'components/Typography'
import { TIME_FORMAT_WITH_PERIOD } from 'constants/datetime'
import { FONT_SIZE } from 'Theme'

interface SessionPeriodTimeProps {
  startDateObject?: Date
  endDateObject?: Date
}

export const SessionPeriodTime: React.FC<SessionPeriodTimeProps> = ({
  startDateObject,
  endDateObject,
}) => (
  <Flex alignItems="center" flexWrap="wrap" data-snapshot-hidden>
    <Text fontSize={FONT_SIZE.PX_16}>
      {`${format(startDateObject, TIME_FORMAT_WITH_PERIOD)} - `}
    </Text>
    <Text fontSize={FONT_SIZE.PX_16}>
      {format(endDateObject, TIME_FORMAT_WITH_PERIOD)}
    </Text>
  </Flex>
)
